var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m238.821282 418v-9h2.732411l.446307-4h-3.178718v-1.948c0-1.03.026311-2.052 1.465602-2.052h1.457805v-2.86c0-.043-1.252192-.14-2.519002-.14-2.645683 0-4.30228 1.657-4.30228 4.7v2.3h-2.923407v4h2.923407v9z","fill":"#1b263a","fillRule":"evenodd","transform":"translate(-232 -398)"}));
}

FacebookIcon.defaultProps = {"height":"20","viewBox":"0 0 10 20","width":"10"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
